import React from "react";
import { FontStyles } from "../utils/font-styles.ts";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { ButtonLink } from "../components/buttons/button-link.tsx";
import { cn } from "../utils/cn.ts";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";
import { TrackEvent } from "../utils/analytics.ts";

export const PropertyReferencePrintSection: React.FC = () => {
  const { displayReference, propertyId, propertySource } = usePropertyDetailsContext();
  const printId =
    propertyId !== undefined
      ? propertySource
        ? `${String(propertyId)}_${propertySource}`
        : String(propertyId)
      : undefined;
  return (
    <div className="flex flex-col md:flex-row gap-3 justify-between md:items-center w-full">
      <p className={cn(FontStyles["body-l"], "!leading-snug")}>
        Property reference: <span className="font-medium">{displayReference}</span>
      </p>
      <ButtonLink
        href={printId !== undefined ? `/property/print?id=${printId}` : "/property/print"}
        renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-print" />}
        label="Print this page"
        colorVariant="secondary"
        variant="outlined"
        onClick={() => {
          TrackEvent({ name: "print_property", value: 5 });
        }}
      />
    </div>
  );
};
